// React Query обвивките на „теоретично срещу реално" в „Продадени продукти /
// рецепти" и на разбивката на продаденото при разнасяне (по сервитьори и
// станции). Ключовете са под ["inventory", "report-postings", …]: числата идват
// от разнасянията и сметките на отчетите, а `invalidateAll` (useInventory.ts)
// вече чисти този префикс след всяка складова мутация — ново/анулирано
// разнасяне опреснява колоните „Разнесено" и панела без нов ред там.
// В локален режим (каса без интернет) складът е извън обхвата → заявките мълчат.
import { useQuery } from "@tanstack/react-query";
import {
  getSoldProductsPosted,
  getSoldRecipeBreakdown,
  type SoldPeriodParams,
} from "../api/inventorySoldAnalysis";
import { getReportSalesBreakdown } from "../api/inventoryReportBreakdown";
import { useIsEdgeLocal } from "./useEdgeMode";

export const useSoldProductsPosted = (params: SoldPeriodParams | null) => {
  const isLocal = useIsEdgeLocal();
  return useQuery({
    queryKey: ["inventory", "report-postings", "sold-products-posted", params],
    queryFn: () => getSoldProductsPosted(params as SoldPeriodParams),
    enabled: !!params && !isLocal,
  });
};

export const useSoldRecipeBreakdown = (sellableId: number | null, params: SoldPeriodParams) => {
  const isLocal = useIsEdgeLocal();
  return useQuery({
    queryKey: ["inventory", "report-postings", "sold-recipe-breakdown", sellableId, params],
    queryFn: () => getSoldRecipeBreakdown({ sellableId: sellableId as number, ...params }),
    enabled: sellableId != null && !isLocal,
  });
};

// Разбивката на продаденото на един отчет при разнасяне — паралелно на прегледа,
// не го блокира. Само информация: грешката е тиха (без toast) и без повторен
// опит — стар BE без пътя отговаря 422 (хваща го като `{posting_id}`).
export const useReportSalesBreakdown = (reportId: number | null) => {
  const isLocal = useIsEdgeLocal();
  return useQuery({
    queryKey: ["inventory", "report-postings", "sales-breakdown", reportId],
    queryFn: () => getReportSalesBreakdown(reportId as number),
    enabled: reportId != null && !isLocal,
    retry: false,
  });
};
